export default __webpack_public_path__ + "static/media/logo-160px.3ef87652.png";